(function (angular) {
  "use strict";

  angular.module("alk.directives")
    .directive("mapsLocation", [function () {
      return {
        restrict: "A",
        replace: false,
        template: "{{vm.location}}",
        scope: {
          mapRegion: "=",
          mapDataset: "=",
          mapObj: "="
        },
        controllerAs: "vm",
        controller: ["$scope", "$timeout", "_", "alkGeocodeService", "STATES", function ($scope, $timeout, _, alkGeocodeService, STATES) {
          var vm = this;
          var map = $scope.mapObj;

          function displayLocation(region, zoom, r) {

            var address = r[0].Address;

            var strCity = address.City + " > ";
            var strCounty = "";

            if (region === "NA") {
              strCounty = (address.County) ? address.County + " County > " : "";
            } else {
              strCounty = (address.County) ? address.County + " > " : "";
            }

            var strState = "";
            var strCountry = "";

            if (region === "NA") {
              // North american states will be in the STATES array so we can get the country, state from their
              var stObj = _.find(STATES, {
                abbreviation: address.State
              });

              if (stObj) {
                strState = stObj.name + " > ";
                strCountry = stObj.country;
              }
            } else {
              // Other regions just use the country. todo: make logic more clear and document logic for what should be displayed for different regions
              strCountry = address.Country;
            }

            switch (true) {
              case (zoom >= 13):
                vm.location = strCity + strCounty + strState + strCountry;
                break;
              case (zoom >= 10):
                vm.location = strCounty + strState + strCountry;
                break;
              case (zoom >= 7):
                vm.location = strState + strCountry;
                break;
              case (zoom < 7):
                vm.location = strCountry;
            }
          }

          function displayError(err) {
            vm.location = "Location unknown";
          }

          function getUpdatedLocation() {
            if (map) {
              var zoom = map.getZoom();

              var center = map.getCenter().transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));

              alkGeocodeService.reverseGeocode(center, {
                  region: $scope.mapRegion,
                  dataset: $scope.mapDataset
                })
                .then(function (r) {
                  return displayLocation($scope.mapRegion, zoom, r);
                }, displayError);
            } else {
              displayError();
            }
          }

          function onMoveEnd() {
            $timeout(function () {
              getUpdatedLocation();
            });
          }

          map.events.register("moveend", {}, onMoveEnd);

          // get the intial location of the map
          getUpdatedLocation();

        }]
      };
    }]);


  angular
    .module("alk.directives")
    .directive("mapsMousePosition", [function () {

      return {
        restrict: "A",
        replace: true,
        template: "<div id=\"mouse-position\"></div",
        scope: {
          mapObj: "="
        },
        controller: ["$scope", "ALKMaps", function ($scope, ALKMaps) {
          var vm = this;
          var map = $scope.mapObj;

          var mousePos = new ALKMaps.Control.MousePosition({
            prefix: "Lon: ", //Optional setting for the text displayed before the longitude value.
            separator: " Lat: ", //Optional setting for text displayed before the latitude value.
            numDigits: 6, //Optional setting for the number of digits to be displayed after the decimal point.
            div: ALKMaps.Util.getElement("mouse-position")
          });

          map.addControl(mousePos);

        }]
      };
    }]);

})(window.angular);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/Maps/mapsLocation.js